import React from 'react';

const OverviewCards = ({ data }) => {
  if (!data) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="overview-cards">
      <div className="period-info">
        <h3>Reporting Period</h3>
        <p>{formatDate(data.period.start_date)} - {formatDate(data.period.end_date)}</p>
      </div>

      <div className="cards-grid">
        {/* TE Overview Card */}
        <div className="overview-card te-card">
          <div className="card-header">
            <h3>TE Overview</h3>
            <div className="card-icon">TE</div>
          </div>
          <div className="card-stats">
            <div className="stat">
              <span className="stat-label">Assigned</span>
              <span className="stat-value">{data.te_stats.assigned}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Completed</span>
              <span className="stat-value">{data.te_stats.completed}</span>
            </div>
            <div className="stat">
              <span className="stat-label">WIP</span>
              <span className="stat-value">{data.te_stats.wip}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Completion Rate</span>
              <span className="stat-value">{data.te_stats.completion_rate}%</span>
            </div>
            <div className="stat">
              <span className="stat-label">Total Word Count</span>
              <span className="stat-value">{data.te_stats.total_word_count.toLocaleString()}</span>
            </div>
          </div>
        </div>

        {/* CE Overview Card */}
        <div className="overview-card ce-card">
          <div className="card-header">
            <h3>CE Overview</h3>
            <div className="card-icon">CE</div>
          </div>
          <div className="card-stats">
            <div className="stat">
              <span className="stat-label">Assigned</span>
              <span className="stat-value">{data.ce_stats.assigned}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Completed</span>
              <span className="stat-value">{data.ce_stats.completed}</span>
            </div>
            <div className="stat">
              <span className="stat-label">WIP</span>
              <span className="stat-value">{data.ce_stats.wip}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Completion Rate</span>
              <span className="stat-value">{data.ce_stats.completion_rate}%</span>
            </div>
            <div className="stat">
              <span className="stat-label">Total Word Count</span>
              <span className="stat-value">{data.ce_stats.total_word_count.toLocaleString()}</span>
            </div>
          </div>
        </div>

        {/* Overall Summary Card */}
        <div className="overview-card overall-card">
          <div className="card-header">
            <h3>Overall Summary</h3>
            <div className="card-icon">ALL</div>
          </div>
          <div className="card-stats">
            <div className="stat">
              <span className="stat-label">Total Articles</span>
              <span className="stat-value">{data.overall.total_articles}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Total Word Count</span>
              <span className="stat-value">{data.overall.total_word_count.toLocaleString()}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Overall Completion</span>
              <span className="stat-value">{data.overall.overall_completion_rate}%</span>
            </div>
            <div className="stat">
              <span className="stat-label">TE WIP</span>
              <span className="stat-value">{data.te_stats.wip}</span>
            </div>
            <div className="stat">
              <span className="stat-label">CE WIP</span>
              <span className="stat-value">{data.ce_stats.wip}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewCards;
